

<mat-toolbar class="topbar horizontal-topbar premium-header-top">
  <div class="container d-flex align-items-center w-100 h-100 justify-content-between p-x-0">
    <div class="header-left-search d-flex align-items-center m-l-4">
      <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-block d-lg-none m-r-8">
        <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
      </button>

      @if (isSearchPage) {
        <form class="custom-form-field">
          <button type="button" class="btn-clean p-0 border-0 bg-transparent d-flex align-items-center cursor-pointer m-r-8" aria-label="Search" (click)="activateSearch()">
            <mat-icon class="search-icon">search</mat-icon>
          </button>
          <input
            type="text"
            autocomplete="off"
            aria-label="Search Users"
            placeholder="Search Users..."
            [formControl]="searchParam"
            (keydown.enter)="activateSearch(); $event.preventDefault()"
            class="bottom-search-input" />
        </form>
      }
    </div>

    <div class="header-right-meta d-flex align-items-center">
      <div class="balance-container d-flex align-items-center m-r-24 p-r-24 b-r-1 text-dark">
        <span class="f-s-14 f-w-500 m-r-8 color-muted-solid">Available Balance:</span>
        <span class="f-s-16 f-w-800 available-balance-text">{{ userData.BALANCE | number: "1.2-2" }}</span>
      </div>

      <div class="user-profile-trigger d-flex align-items-center cursor-pointer" [matMenuTriggerFor]="profilemenu">
        <div class="avatar-circle m-r-12">
          <mat-icon color="primary" class="d-flex align-items-center justify-content-center">account_circle</mat-icon>
        </div>
        <div class="user-meta d-flex flex-column">
          <span class="f-s-14 username-text">{{ userData.NAME }}</span>
          <span class="role-text text-uppercase">{{ userData.ROLE_NAME }}</span>
        </div>
        <mat-icon class="m-l-8 text-muted f-s-18">expand_more</mat-icon>
      </div>
    </div>
  </div>

    <mat-menu #profilemenu="matMenu" xPosition="before" class="topbar-dd cardWithShadow p-20">
      <div class="p-x-16">
        <h6 class="f-s-16 f-w-600 m-0">User Profile</h6>

        <div class="d-flex align-items-center p-b-12 b-b-1 m-t-16">
          <span class="f-s-14 d-block m-b-4">{{ userData.ROLE_NAME }}</span>
        </div>
      </div>
      <div class="p-x-10">
        @for (profile of profiledd; track profile) {
          <a class="p-y-16 text-decoration-none d-block text-hover-primary" [routerLink]="['home/my-account']">
            <div class="d-flex align-items-center">
              <button mat-mini-fab class="text-white bg-light-success shadow-none rounded">
                <mat-icon color="primary">person</mat-icon>
              </button>

              <div class="m-l-16">
                <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                  {{ profile.title }}
                </h5>
                <span class="mat-body-1">{{ profile.subtitle }}</span>
              </div>
            </div>
          </a>
        }
      </div>

      <div class="p-x-10">
        <a class="text-decoration-none d-block text-hover-primary" (click)="logOut()">
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-primary bg-light-success shadow-none rounded">
              <mat-icon color="primary">logout</mat-icon>
            </button>

            <div class="m-l-16">
              <a class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text cursor-pointer"> Log Out </a>
            </div>
          </div>
        </a>
      </div>
    </mat-menu>
</mat-toolbar>
